import { render, staticRenderFns } from "./nota-input.vue?vue&type=template&id=03929b2b"
import script from "./nota-input.vue?vue&type=script&lang=js"
export * from "./nota-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports